import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Sectors from "@/components/Sectors";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import useReveal from "@/lib/useReveal";

const Home = () => {
  useReveal();

  useEffect(() => {
    document.title =
      "INFRATELCO · Infraestructura tecnológica industrial · Saltillo, Coahuila";
  }, []);

  return (
    <main className="min-h-screen bg-[#181C24] text-[#F0F0F1]" data-testid="home-page">
      <Nav />
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Sectors />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
